import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './TopNav.css';

const TopNav = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const catechistFullName = localStorage.getItem('catechistFullName') || 'Giáo lý viên';
  const userRole = localStorage.getItem('userRole') || 'catechist';
  const boardLeader = localStorage.getItem('boardLeader') || '';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('catechistFullName');
    localStorage.removeItem('username');
    localStorage.removeItem('catechistHolyName');
    localStorage.removeItem('catechistClassName');
    localStorage.removeItem('userRole');
    localStorage.removeItem('rememberedUsername');
    localStorage.removeItem('rememberedPassword');
    localStorage.removeItem('boardLeader');
    navigate('/login');
  };

  const handleProfileClick = () => {
    setIsDropdownOpen(false);
    navigate('/main/profile');
  };

  const handleAdminManagementClick = () => {
    setIsDropdownOpen(false);
    navigate('/admin-management');
  };

  const handleDisciplineBoardClick = () => {
    setIsDropdownOpen(false);
    navigate('/discipline-board');
  };

  return (
    <nav className="top-nav">
      <a href='/main/' style={{textDecoration: 'none'}}>
        <div className="nav-left">
          <img src="/logo.png" alt="Logo" className="nav-logo" />
          <h1>
            Hệ Thống Điểm Danh
          </h1>
        </div>
      </a>
      <div className="nav-right" ref={dropdownRef}>
        <div
          className="user-info"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <span>{catechistFullName}</span>
          <span className={`arrow ${isDropdownOpen ? 'up' : 'down'}`}>▼</span>
        </div>
        {isDropdownOpen && (
          <div className="dropdown-menu">
            {userRole === 'admin' && (
              <button onClick={handleAdminManagementClick}>Ban Điều Hành</button>
            )}
            {boardLeader === 'Ban kỷ luật' && (
              <button onClick={handleDisciplineBoardClick}>Ban kỷ luật</button>
            )}
            <hr />
            <button onClick={handleProfileClick}>Thông tin giáo lý viên</button>
            <button onClick={handleLogout}>Đăng xuất</button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default TopNav;